module.exports = __webpack_public_path__ + "img/icon_caret.17e7d028.svg";